import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.progress)
        ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
            key: 0,
            type: "indeterminate",
            color: "secondary"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.closeCircle
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_action")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { disabled: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { slot: "icon-only" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createVNode(_component_Form, {
            onSubmit: _ctx.onSubmit,
            initialValues: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n("common_areyousure")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_hives")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Field, {
                        name: "hives",
                        rules: _ctx.hives_value
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_ion_input, _mergeProps(field, {
                            type: "number",
                            min: "0"
                          }), null, 16)
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "hives",
                        as: "div",
                        class: "form-error"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_last_hour")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Field, {
                        name: "last_hour",
                        rules: _ctx.hours_between
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_ion_input, _mergeProps(field, {
                            type: "number",
                            min: "19",
                            max: "23"
                          }), null, 16)
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "last_hour",
                        as: "div",
                        class: "form-error"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_grid, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_button, {
                  type: "submit",
                  fill: "solid",
                  expand: "full",
                  disabled: _ctx.progress
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.i18n("common_confirm")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "initialValues"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}